import { render } from "./PinAddDropdown.vue?vue&type=template&id=2d020e34&scoped=true"
import script from "./PinAddDropdown.vue?vue&type=script&lang=js"
export * from "./PinAddDropdown.vue?vue&type=script&lang=js"

import "./PinAddDropdown.vue?vue&type=style&index=0&id=2d020e34&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-2d020e34"

export default script